module.exports = __webpack_public_path__ + "static/media/Vestnik.f41e798e.png";